<template>
  <div class="container">
    <div class="footer-top">
      <div class="one">
        <div class="logo">Scan2Word</div>

        <div class="web-desc">
          <span
            >PDF/扫描件/图片内容，OCR一键提取<br />在原文件排版基础上编辑更轻松！</span
          >
        </div>
      </div>

      <div class="line two">
        <ul>
          <li><span class="section-title"> 关于Scan2Word</span></li>
          <li>
            <router-link to="/use-cases"> 使用场景 </router-link>
          </li>
          <li>
            <router-link to="/faq"> 帮助中心 </router-link>
          </li>
          <li>
            <router-link to="/privacy">隐私政策</router-link>
          </li>
        </ul>
      </div>

      <div class="line three">
        <ul>
          <li><span class="section-title"> 热门功能</span></li>
          <li>
            <router-link to="/convert-scans-to-editable-docs?type=pdf">
              PDF转Word
            </router-link>
          </li>
          <li>
            <router-link to="/convert-scans-to-editable-docs?type=ocr">
              OCR文字识别
            </router-link>
          </li>
          <li>
            <router-link to="/convert-scans-to-editable-docs?type=table">
              表格格式保留
            </router-link>
          </li>
        </ul>
      </div>
      <div></div>
      <div class="four">
        <p class="title">欢迎关注我们！</p>
        <div class="share">
          <a
            href="https://weibo.com/u/7801475619"
            target="_blank"
            rel="noopener noreferrer"
            ><img
              class="mes1-img4 mes1-img3"
              src="@/assets/footer/weibo@2x.png"
          /></a>
          <a
            href="https://space.bilibili.com/3493082492307981"
            target="_blank"
            rel="noopener noreferrer"
            ><img class="mes1-img3" src="@/assets/footer/bli@2x.png"
          /></a>
          <a
            href="https://www.douyin.com/user/MS4wLjABAAAAmw4OECeC_h99HztB5UBHvYfn-YiMEcPXl2yJS-N6KAnweTCG7lj0CjphAdexv-me"
            target="_blank"
            rel="noopener noreferrer"
            ><img class="mes1-img3" src="@/assets/footer/douyin@2x.png"
          /></a>
          <a
            href="https://www.xiaohongshu.com/user/profile/612727540000000001015dc3"
            target="_blank"
            rel="noopener noreferrer"
            ><img class="mes1-img3" src="@/assets/footer/redbook@2x.png"
          /></a>
          <a
            href="https://live.kuaishou.com/profile/3x7is74pdrkt8zy?fid=3657657724&cc=share_copylink&followRefer=151&shareMethod=TOKEN&kpn=KUAISHOU&subBiz=PROFILE&shareId=18329259968747&shareToken=X-74jCkGXQRZD11c&shareResourceType=PROFILE_SELF&shareMode=APP&originShareId=18329259968747&appType=21&shareObjectId=3657657724&shareUrlOpened=0&timestamp=1742518712785"
            target="_blank"
            rel="noopener noreferrer"
            ><img class="mes1-img3" src="@/assets/footer/kauishou@2x.png"
          /></a>
        </div>
        <a
          class="email"
          href="mailto:Scan2Word@czyh100.com"
          target="_blank"
          rel="noopener noreferrer"
          >联系邮箱：Scan2Word@czyh100.com</a
        >
      </div>
    </div>

    <div class="footer-bottom">
      <a
        href="https://beian.miit.gov.cn"
        target="_blank"
        rel="noopener noreferrer"
        >沪ICP备2024098850号-5</a
      >
      <a
        href="https://beian.mps.gov.cn/#/query/webSearch?code=31011002007268"
        rel="noreferrer"
        target="_blank"
        >
        <img src="@/assets/footer/gongan.png" alt="police" />
        沪公网安备31011002007268号
        </a
      >
    </div>
  </div>
</template>

<style lang="less" scoped>
.container {
  width: 100%;
  background: url("@/assets/footer.png") no-repeat center center;
  .footer-top {
    display: flex;
    justify-content: space-between;
    padding: 44px 140px 0 140px;

    .line {
      color: #fff;

      li {
        margin-bottom: 16px;
        .section-title {
          font-size: 20px;
        }
      }

      a {
        color: #fff;
        font-size: 16px;
        text-align: left;
      }
    }

    .one {
      white-space: nowrap;
      .logo {
        font-weight: 600;
        font-size: 20px;
        color: #ffffff;
        text-align: left;
        font-style: normal;
      }

      .web-desc {
        font-weight: 400;
        font-size: 16px;
        color: #ffffff;
        line-height: 24px;
        text-align: left;
        font-style: normal;
        margin-top: 22px;
      }
    }

    .two {
      white-space: nowrap;
    }

    .three {
      white-space: nowrap;
    }

    .four {
      .title {
        color: #fff;
        font-size: 20px;
      }

      .share {
        margin: 40px 0;
        a {
          display: inline-block;
          img {
            margin-right: 30px;
            width: 40px;
          }
        }
      }
      .email {
        font-weight: 400;
        font-size: 16px;
        color: #ffffff;
        font-style: normal;
      }
    }

    li {
      list-style: none;
      a {
        color: #666;
        text-decoration: none;
        white-space: nowrap;
      }
    }

    li:hover a {
      color: #fff;
    }
  }

  .footer-bottom {
    background-color: #000;
    width: 100%;
    margin-top: 60px;
    padding-bottom: 20px;
    text-align: center;
    display: flex;
    flex-direction: column;
    a {
      color: #fff;
      opacity: 0.6;
      font-size: 14px;
      margin: 4px 0;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 15px;
        margin: 0 3px;
      }
    }
  }
}
</style>